import directTeams from "../data/directTeams.json";
import { Team } from "../types/team";

export function getAllQualifiedTeams(): Team[] {
  return directTeams as Team[];
}
